import clsx from 'clsx'
import { useState } from 'react'
import InlineLoader from '../InlineLoader'

export default function EmailPrompt({
  title,
  subtitle,
  defaultValue = '',
  maxLength = 50,
  error,
  primaryLoading = false,
  secondaryLoading = false,
  onChange,
  onPrimary,
  primaryLabel = 'Continue',
  primaryClassName = 'sb-button sb-button--primary',
}) {
  const [email, setEmail] = useState(defaultValue)

  const handleChange = (event) => {
    const next = event.target.value.trim()
    setEmail(next)
    onChange?.(next)
  }

  return (
    <form className="sb-pop-up-wrapper__content-wrapper">
      <div className="db_forgot_password_pop_up__wrapper">
        {title ? (
          <div className="sb-pop-up-wrapper__heading" style={{ marginBottom: '.25rem' }}>
            {title}
          </div>
        ) : null}
        {subtitle ? <p className="db_forgot_password_pop_up__hint">{subtitle}</p> : null}

        <label className="sb-text-input__layout">
          <div
            className={clsx('sb-text-input__wrapper', {
              'sb-text-input__wrapper--error': Boolean(error),
            })}
          >
            <span className={clsx('sb-text-input__label', { '': Boolean(error) })}>Email</span>
            <input
              className={clsx('sb-text-input__input', { 'sb-text-input__input': Boolean(error) })}
              name="email"
              placeholder="Email"
              type="email"
              maxLength={maxLength}
              value={email}
              onChange={handleChange}
            />
          </div>
          {error && <p className="sb-text-input__hint sb-text-input__hint--error">{error}</p>}
        </label>

        <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
          <button
            className={primaryClassName}
            disabled={primaryLoading}
            style={{ flex: 1 }}
            onClick={() => onPrimary?.(email)}
          >
            {primaryLoading ? <InlineLoader /> : primaryLabel}
          </button>
        </div>
      </div>
    </form>
  )
}
